import { useTranslation } from '#/contexts/useTranslation';
import { cn } from '#/lib/utils';
import { Check } from 'lucide-react';
import { ComponentProps, ReactNode } from 'react';

interface Props extends ComponentProps<'ol'> {
  selectedIndex?: number;
}

export function Steps({ selectedIndex = -1, className, ...props }: Props) {
  const translation = useTranslation(
    translation => translation.my_staking.Validators.Dialog
  );
  const data = [
    translation.DestinationValidator,
    translation.SelectSourceValidators,
    translation.Confirmation,
  ];
  return (
    <ol
      {...props}
      className={cn('flex items-center justify-evenly', className)}
    >
      {data.map((item, i) => (
        <Step
          key={i}
          label={item}
          item={item}
          itemIndex={i}
          selectedIndex={selectedIndex}
        />
      ))}
    </ol>
  );
}

interface StepProps {
  item?: any;
  itemIndex?: number;
  selectedIndex?: number;
  label: ReactNode;
}
function Step({ itemIndex = 0, label, selectedIndex = -1 }: StepProps) {
  const isSelected = selectedIndex === itemIndex;
  const isCompleted = selectedIndex > itemIndex;
  const icon = isCompleted ? <Check className="w-3 h-3" /> : itemIndex + 1;
  return (
    <>
      {itemIndex !== 0 && (
        <div className="flex items-center self-start h-5">
          <div
            className={cn('h-px w-20 text-gray-500 bg-current', {
              'text-blue-600': isSelected || isCompleted,
            })}
          />
        </div>
      )}
      <li
        className={cn('flex flex-col gap-1 items-center text-gray-500', {
          'text-blue-600': isSelected || isCompleted,
        })}
      >
        <div
          className={cn(
            'rounded-full w-5 h-5 bg-slate-100 text-xs flex items-center justify-center',
            {
              'border-2 border-current': !isCompleted,
              'bg-blue-100': isCompleted,
            }
          )}
        >
          {icon}
        </div>
        <div className={cn('text-sm', { 'font-bold': isSelected })}>
          {label}
        </div>
      </li>
    </>
  );
}
